
/*
  UXS — MP3 ENCODER V1
  DAY2K / UNIDOS X EL SONIDO

  Convierte VOICE 002 de WAV a MP3:
  128 kbps / mono / 44.1 kHz.

  NO modifica el archivo original.
  NO sube ni comparte grabaciones.
*/

(function () {
  "use strict";

  const RATE = 44100;
  const BITRATE = 128;

  let currentMP3 = null;
  let processing = false;
  let generation = 0;

  function getStatus() {
    let element = document.getElementById(
      "uxs-mp3-status"
    );

    if (!element) {
      element = document.createElement("p");
      element.id = "uxs-mp3-status";

      Object.assign(element.style, {
        color: "rgba(255,255,255,.5)",
        fontFamily: "monospace",
        fontSize: "10px",
        letterSpacing: "1px",
        lineHeight: "1.8",
        textAlign: "center"
      });

      const panel = document.getElementById(
        "uxs-transcription-panel"
      );

      if (panel) panel.appendChild(element);
    }

    return element;
  }

  function setStatus(message) {
    const element = getStatus();
    if (element) element.textContent = message;
  }

  function reset() {
    generation++;
    currentMP3 = null;
    processing = false;
    setStatus("");
  }

  async function encode() {
    if (processing) return null;

    if (typeof window.lamejs?.Mp3Encoder !== "function") {
      throw new Error("MP3_ENCODER_NOT_LOADED");
    }

    const audio = document.getElementById(
      "uxs-vocoder-player"
    );

    const src = audio?.getAttribute("src");

    if (!src) {
      throw new Error("VOICE_002_NOT_READY");
    }

    const myGeneration = generation;

    processing = true;
    setStatus("PREPARANDO TU SEÑAL...");

    let context = null;

    try {
      const response = await fetch(src);

      if (!response.ok) {
        throw new Error("AUDIO_UNAVAILABLE");
      }

      const wav = await response.arrayBuffer();

      context = new (
        window.AudioContext ||
        window.webkitAudioContext
      )();

      const decoded = await context.decodeAudioData(
        wav.slice(0)
      );

      // Convertir a 44.1 kHz.
      const length = Math.ceil(
        decoded.duration * RATE
      );

      const offline = new OfflineAudioContext(
        1,
        length,
        RATE
      );

      const source = offline.createBufferSource();
      source.buffer = decoded;
      source.connect(offline.destination);
      source.start(0);

      const rendered = await offline.startRendering();

      const floatSamples =
        rendered.getChannelData(0);

      const samples = new Int16Array(
        floatSamples.length
      );

      for (let i = 0; i < floatSamples.length; i++) {
        const sample = Math.max(
          -1,
          Math.min(1, floatSamples[i])
        );

        samples[i] = sample < 0
          ? sample * 32768
          : sample * 32767;
      }

      const encoder = new window.lamejs.Mp3Encoder(
        1,
        RATE,
        BITRATE
      );

      const chunks = [];
      const blockSize = 1152;

      for (
        let i = 0;
        i < samples.length;
        i += blockSize
      ) {
        if (myGeneration !== generation) {
          return null;
        }

        const block = samples.subarray(
          i,
          i + blockSize
        );

        const encoded = encoder.encodeBuffer(block);

        if (encoded.length) {
          chunks.push(new Uint8Array(encoded));
        }
      }

      const remaining = encoder.flush();

      if (remaining.length) {
        chunks.push(new Uint8Array(remaining));
      }

      const blob = new Blob(chunks, {
        type: "audio/mpeg"
      });

      if (myGeneration !== generation) {
        return null;
      }

      if (!blob.size) {
        throw new Error("EMPTY_MP3");
      }

      currentMP3 = blob;

      setStatus(
        "TU SEÑAL ESTÁ LISTA EN MP3."
      );

      document.getElementById(
        "uxs-experience"
      )?.dispatchEvent(
        new CustomEvent("uxs:mp3-ready", {
          bubbles: true,
          detail: {
            size: blob.size,
            type: blob.type
          }
        })
      );

      return blob;

    } finally {
      processing = false;

      if (context) {
        await context.close().catch(() => {});
      }
    }
  }

  window.UXSMP3 = {
    encode,

    getBlob() {
      return currentMP3;
    },

    reset
  };

  function initialize() {
    const root = document.getElementById(
      "uxs-experience"
    );

    if (!root) return;

    root.addEventListener(
      "uxs:audio-cleared",
      reset
    );

    root.addEventListener(
      "uxs:transcription-confirmed",
      async () => {
        try {
          await encode();
        } catch (error) {
          console.error("UXS MP3:", error);

          setStatus(
            "NO SE PUDO PREPARAR EL MP3."
          );
        }
      }
    );

    console.log("UXS MP3 Encoder V1 Ready");
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialize
    );
  } else {
    initialize();
  }
})();
